<template>
  <q-page>
    <div class="container" :class="{'q-pt-none': isApp}">
      <div class="bluesquareBox">
        <img v-show="!isMobile" class="help_img" src="../images/help_img.png" alt="">
        <div v-show="isMobile" class="bluesquare">
          <span>{{ text[0].title }}</span>  
          <p v-show="isMobile" class="bluesquare_mobiletext" >{{ text[0].contents }}</p>
        </div>
      </div>
      <section class="sec01">
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_1.png" alt="1번"/>
            <p class="title">{{ text[1].title }}</p>
            <p class="contents">{{ text[1].contents }}</p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox_2">
            <img class="contents_img" src="../images/help1.png" alt="">
          </div>
        </article>
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_2.png" alt="2번"/>
            <p class="title">{{ text[2].title }}</p>
            <p class="contents" v-html="text[2].contents"></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox_2">
            <img v-if="isMobile" class="contents_img" src="../images/help2_mobile.png" alt="">
            <img v-else class="contents_img" src="../images/help2.png" alt="">
          </div>
        </article>
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_3.png" alt="3번"/>
            <p class="title">{{ text[3].title }}</p>
            <p v-if="isMobile" class="contents" v-html="text[3].contents.mobile"></p>
            <p v-else class="contents" v-html="text[3].contents.pc"></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox_2">
            <img class="contents_img" src="../images/help3.png" alt="">
          </div>
        </article>
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_4.png" alt="4번" />
            <p class="title">{{ text[4].title }}</p>
            <p v-if="isMobile" class="contents" v-html="text[4].contents.mobile"></p>
            <p v-else class="contents" v-html="text[4].contents.pc"></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox_2">
            <img class="contents_img" src="../images/help4.png" alt="">
          </div>
        </article>
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_5.png" alt="5번"/>
            <p class="title">{{ text[5].title }}</p>
            <p v-if="isMobile" class="contents" v-html="text[5].contents.mobile"></p>
            <p v-else class="contents" v-html="text[5].contents.pc"></p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox_2">
            <img v-if="isMobile" class="contents_img" src="../images/help5_mobile.png" alt="">
            <img v-else class="contents_img" src="../images/help5.png" alt="">
          </div>
        </article>
        <article class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 contentsBox">
            <img class="number" src="../images/help_num_6.png" alt="6번"/>
            <p class="title">{{ text[6].title }}</p>
            <p class="contents">{{ text[6].contents }}</p>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 text-center contentsBox_2">
            <img class="contents_img" src="../images/help6.png" alt="">
          </div>
        </article>
      </section>
    </div>
  </q-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

  export default {
    name: 'Help',
    props: {
      isMobile: Boolean
    },
    data() {
      return {
        downloadLink: {
          appStore: 'https://apps.apple.com/kr/app/safeotp-%EC%A0%84%EC%9E%90%EC%84%9C%EB%AA%85-%EA%B8%B0%EB%B0%98/id1472679070?mt=8',
          playStore: 'http://play.google.com/store/apps/details?id=kr.co.eightbyte.safeotp'
        },
        text: [
          {
            title: '도움말',
            contents: '사용법을 알아봐요!',
            img:'../images/line.png'
          },
          {
            numImg: '@/images/help_num_1.png',
            title: 'PIN 등록(생체 인증 가능)',
            contents: '안전한 APP 사용을 위해 6자리 PIN을 등록하세요.',
            contentImg: '../images/help1.png'
          },
          {
            numImg: '../images/help_num_2.png',
            title: 'OTP 등록',
            contents: '+ 버튼을 눌러 OTP를 등록하세요. <br />OTP 신청 시 받은 인증 번호 혹은 QR코드를 입력해주세요. <br /> OTP는 복수 등록이 가능합니다.',
            contentImg: '../images/help2.png'
          },
          {
            numImg: '../images/help_num_3.png',
            title: '복구 기능',
            contents: {
              mobile: ' OTP 처음 등록 시 복구 코드가 발급됩니다. <br />'
                + '핸드폰 변경/분실 후 다시 등록 시 <br /> 복구 코드 하나로 모든 OTP 정보가 복구됩니다. <br />'
                + '(복구 코드는 안전한 곳에 따로 보관하세요!)',
              pc: 'OTP 처음 등록 시 복구 코드가 발급됩니다. <br />' 
                + '핸드폰 변경/분실 후 다시 등록 시 복구 코드 하나로 모든 OTP 정보가 복구됩니다.<br />'
                + '(복구 코드는 안전한 곳에 따로 보관하세요!)'
            },
            contentImg: '../images/help3.png'
          },
          {
            numImg: '../images/help_num_4.png',
            title: 'OTP 생성',
            contents: {
              mobile: 'OTP 생성 먼저 사이트에서 OTP 요청 후 앱을 실행하세요.<br />'
                + '앱에서 해당 사이트의 계정을 선택하여 OTP를 생성하세요! <br />'
                + '생성된 OTP를 사이트에 입력하여 안전한 거래를 하세요!',
              pc: 'OTP 생성 먼저 사이트에서 OTP 요청 후 앱을 실행하세요.<br />' 
                + '앱에서 해당 사이트의 계정을 선택하여 OTP를 생성하세요! <br />'
                + '생성된 OTP를 사이트에 입력하여 안전한 거래를 하세요!'
            },
            contentImg: '../images/help4.png'
          },
          {
            numImg: '../images/help_num_5.png',
            title: 'OTP 관리 (갱신 및 삭제)',
            contents: {
              mobile: '자주쓰는 OTP를 지정하세요! 안쓰는 OTP가 있으면 앱 내에서 삭제가 가능합니다.<br />'
                + '(OTP 해지는 가입한 사이트에서만 가능합니다.)<br />'
                + '만료일이 다가오면 별도의 등록없이 갱신이 가능합니다.<br />'
                + '(만료일이 지나면 갱신이 불가합니다.)',
              pc: '자주쓰는 OTP를 지정하세요! <br />' 
                + '안쓰는 OTP가 있으면 앱 내에서 삭제가 가능합니다.'
                + '(OTP 해지는 가입한 사이트에서만 가능합니다.) <br />'
                + '만료일이 다가오면 별도의 등록없이 갱신이 가능합니다. (만료일이 지나면 갱신이 불가합니다.)'
            },
            contentImg: {
              mobile: '../images/help5_mobile.png',
              pc: '../images/help5.png'
            }
          },
          {
            numImg: '../images/help_num_6.png',
            title: '설정',
            contents: 'SAFEOTP에 다양한 설정을 확인하세요.',
            contentImg: '../images/help6.png'
          }
        ]
      }
    },
    created() {
      this.saveView('')
      this.savePosition('help')
    },
    computed: {
      ...mapState ({
        isApp: state => state.session.isApp
      })
    },
    methods: {
      ...mapActions({ 
        saveView: 'session/save_exerciseView',
        savePosition: 'session/save_position'    
      })
    }
  }
</script>

<style scoped>
  .q-pt-none {
    padding-top: 0!important;
  }
  .bluesquare {
    position: relative;
    background-color: #3076FF;
    color: white;
  }
  /*  
    모바일 버전 
  */
  /* iPhone 5/SE */
  @media screen and (max-width: 320.98px) {
    section.sec01 > article {
      margin-bottom: 40px!important;
    }
    .number {
      width: 40px!important;
    }
    .title {
      font-size: 20px!important;
      margin: .6rem 0!important;
    }
    .contents_img {
      max-width: 300px!important;
    }
    .contents {
      font-size: 11px!important;
      margin: 1rem!important;
    }
  }
  @media screen and (min-width: 321px) and (max-width: 599.98px) {
    section.sec01 > article {
      margin-bottom: 50px!important;
    }
    .number {
      width: 45px!important;
    }
    .title {
      font-size: 25px!important;
      margin: .8rem 0!important;
    }
    .contents_img {
      max-width: 320px!important;
    }
    .contents {
      font-size: 14px!important;
      margin: 1.2rem!important;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 768.98px) {    
    section.sec01 > article {
      margin-bottom: 70px!important;
    } 
    .number {
      width: 50px!important;
    }
    .title {
      font-size: 25px!important;
     
    }
    .contents_img {
      max-width: 500px!important;
    }
    .contents {
      font-size: 19px!important;
       
    }
  }
  @media screen and (min-width: 769px) and (max-width: 1023.98px) {
   
    /* .bluesquare {
      font-size: 17px;
      padding-left: 20px;
      padding-top: 15px;
      height: 140px;
    }
    .sec01 {
      padding: 50px;
    }
    .contentsBox {
      text-align: center;
    }
    .title {
      font-size: 22px;
    }
    .contents {
      font-size: 14px;
      font-weight: 550;
    }
    
    .number {
      width: 40px; 
    } */
  }
  @media screen and (max-width: 1023.98px) {
    div.container {
      padding-top: 50px;
    }
    .bluesquare {
      font-size: 24px;
      height: 350px;
      width: 100%;
      padding-top: 20px;
      padding-left: 20px;
    }
    .bluesquare_mobiletext{
      position: absolute;
      font-size: 12px;
      color: black;
      bottom: 20px;
      right: 40px;
      font-weight: bold;
    }
    section.sec01 > article {
      margin-bottom: 100px;
    }
    section.sec01 {
      padding-top: 70px;
    }
    .contentsBox {
      text-align: center;
    }
    .number{
      width: 55px;
    }
    .title{
      font-weight: bold;
      text-align: center;
      font-size: 30px;
      margin: 1rem 0;
    }
    .contents{
      margin: 1.5rem;
      color: #5F5F5F;
      text-align: center;
      font-size: 19px;
      font-weight: 550;
    }
    .contents_img {
      max-width: 600px;
      width: 100%;
    }
    .contentsBox_2{
      text-align: center;
    }

  } 
  /*  
    PC 버전 
  */
  @media screen and (min-width: 1024px) {
    div.container {
      padding: 70px 100px;
    }
    .sec01 article {
      padding: 70px 0;
    }
    .title {
      color: #3076FF;
      font-weight: bold;
      font-size: 25px;
    }
    .contents {
      color: #454545;
      font-size: 14px;
      font-weight: 550;
    }
    .contents_img {
      width: 100%;
      max-width: 500px;
    }
    .contentsBox {
      padding-right: 70px;
    }
    .contentsBox_2{
      text-align: right;
    }
    .number {
      width: 40px; 
    }
    .help_img {
      width: 100%;
      overflow: hidden;
    }
  }
  
  @media screen and (min-width: 1024px) and (max-width: 1439.98px) {}
  @media screen and (min-width: 1440px) and (max-width: 1999.98px) {
    div.container {
      padding: 70px 200px;
    }
    .sec01 article {
      padding: 100px 0;
    }
    .title {
      font-size: 30px;
    }
    .contents {
      font-size: 16px;
      font-weight: 600;
    }
    .contents_img {
      max-width: 550px;
    }
    .contentsBox {
      padding-right: 100px;
    }
    .number {
      width: 50px; 
    }
  }
  @media screen and (min-width: 2000px) {
    div.container {
      padding: 70px 300px;
    }
    .sec01 article {
      padding: 120px 0;
    }
    .title {
      font-size: 35px;
    }
    .contents {
      font-size: 18px;
      font-weight: 600;
    }
    .contents_img {
      max-width: 600px;
    }
    .contentsBox {
      padding-right: 120px;
    }
    .number {
      width: 55px; 
    }
  } 
</style>

